import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppGlobalsService } from '../services/app-globals.service';
import { PostTradeComponent } from './post-trade-shell/post-trade.component';
import { PostTradeReportsComponent } from './post-trade-reports/post-trade-reports.component';
import { TradeReviewComponent } from './trade-review/trade-review-shell/trade-review.component';
import { AccountReviewComponent } from './account-review/account-review-shell/account-review.component';
import { RepReviewComponent } from './rep-review/rep-review-shell/rep-review.component';
import { AmlMonitorComponent } from './aml-monitor/aml-monitor-shell/aml-monitor.component';
import { AccountGroupingComponent } from './account-grouping/account-grouping-shell/account-grouping.component';
import { TradeSourceDataComponent } from './trade-source-data/trade-source-data.component';
import { AuthService } from '../services/auth-service.service';

const routes: Routes = [
  {
    path: 'post-trade',
    resolve: {
      globals: AppGlobalsService,
    },
    children: [
      {
        path: '',
        component: PostTradeComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'PostTrade',
          breadcrumb: 'Post Transaction',
        },
      },
      {
        path: 'reports',
        component: PostTradeReportsComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'PostTrade',
          breadcrumb: 'Transaction Monitor',
        },
      },
      {
        path: ':view',
        component: PostTradeComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'PostTrade',
          breadcrumb: 'Post Transaction',
        },
      },
    ],
  },
  {
    path: 'trade-review',
    resolve: {
      globals: AppGlobalsService,
    },
    children: [
      {
        path: '',
        component: TradeReviewComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'TradeReview',
          breadcrumb: 'Transaction Monitor',
        },
      },
      {
        path: ':id',
        component: TradeReviewComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'TradeReview',
          breadcrumb: 'Transaction Monitor',
        },
      },
    ],
  },
  {
    path: 'account-review',
    resolve: {
      globals: AppGlobalsService,
    },
    children: [
      {
        path: '',
        component: AccountReviewComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'AccountReview',
          breadcrumb: 'Account Monitor',
        },
      },
      {
        path: ':id',
        component: AccountReviewComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'AccountReview',
          breadcrumb: 'Account Monitor',
        },
      },
    ],
  },
  {
    path: 'rep-review',
    resolve: {
      globals: AppGlobalsService,
    },
    children: [
      {
        path: '',
        component: RepReviewComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'RepReview',
          breadcrumb: 'Financial Professional Monitor',
        },
      },
      {
        path: ':id',
        component: RepReviewComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'RepReview',
          breadcrumb: 'Financial Professional Monitor',
        },
      },
    ],
  },
  {
    path: 'aml-monitor',
    resolve: {
      globals: AppGlobalsService,
    },
    children: [
      {
        path: '',
        component: AmlMonitorComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'AML',
          breadcrumb: 'Anti-Money Laundering Monitor',
        },
      },
      {
        path: ':id',
        component: AmlMonitorComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'AML',
          breadcrumb: 'Anti-Money Laundering Monitor',
        },
      },
    ],
  },
  {
    path: 'account-grouping',
    resolve: {
      globals: AppGlobalsService,
    },
    children: [
      {
        path: '',
        component: AccountGroupingComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'AccountGroup',
          breadcrumb: 'Account Grouping',
        },
      },
      {
        path: ':id',
        component: AccountGroupingComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'AccountGroup',
          breadcrumb: 'Account Grouping',
        },
      },
    ],
  },
  {
    path: 'trade-source-data',
    resolve: {
      globals: AppGlobalsService,
    },
    children: [
      {
        path: '',
        component: TradeReviewComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'TradeReview',
          breadcrumb: 'Transaction Monitor',
        },
      },
      {
        path: ':id',
        component: TradeSourceDataComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'TradeReview',
          breadcrumb: 'Transaction Source Data',
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PostTradeRouting {}
